import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Alert } from "reactstrap"; 

const customizableOrg = parseInt(process.env.REACT_APP_FINALIZE_MESSAGE_CUSTOMIZABLE_ORG || 0);

const CustomizedText = ({ t }) => {
    return (
        <>
            <div className="mb-3">
                <i className="mdi mdi-check-all me-2"></i>
                <b>{t("Your complaint has been successfully submitted.")}</b>
            </div>

            <p className="mb-2">
                {t("Provided that your complaint concerns matters falling within the remit of the Auditor General and there are no pending court proceedings or police investigations, our Office will consider conducting an investigation.")}
            </p>

            <p className="mb-2">
                {t("Any findings may be included in a Special Report to be issued by our Office in the future.")}
            </p>

            <p className="mb-2">
                {t("Please note that the resolution of disputes between citizens and government agencies does not fall within the remit of the Auditor General.")}
            </p>

            <p className="mb-2">
                {t("Competence to examine complaints against agencies or officials exercising executive power or administrative functions, for any action that violates human rights or was taken in violation of the laws or rules of good administration and proper conduct towards citizens, lies with the Commissioner for Administration and the Protection of Human Rights. Therefore, if your complaint falls into the above category, you should address it to the Commissioner for Administration and the Protection of Human Rights.")}
            </p>

            <p className="mb-2">
                {t("Citizens also have the right to seek legal redress, in the manner and under the conditions specified in the Constitution and applicable legislation.")}
            </p>

            <p className="mb-0">
                {t("Thank you for contacting the Audit Office.")}
            </p>
        </>
    )
}

const GeneralText = ({ t, privateEmailChanged }) => {
    return (
        <>
            <div className="mb-3">
                <i className="mdi mdi-check-all me-2"></i>
                <b>{t("Report Submitted")}</b>
            </div>

            {privateEmailChanged && (
                <p className="mb-2">
                    {t(
                        "You have successfully changed your private email address. This email will be used for further communication regarding anonymous reports."
                    )}
                </p>
            )}

            <p className="mb-2">
                {t(
                    "If you have any questions, please contact the technical support by sending an email to support@diss-co.tech."
                )}
            </p>

            <p className="mb-0">
                {t(
                    "If you receive error messages or have a technical questions, please make a screenshot of the error message or your view including the URL and send your request by email to support@diss-co.tech"
                )}
            </p>
        </>
    )
}

const FinalizeMessage = ({ t, organization, privateEmailChanged = false }) => {
    return (
        <Alert
            color="success"
            className="alert-dismissible fade show"
            role="alert"
        >
            {parseInt(organization.id) === customizableOrg ? (
                <CustomizedText 
                    t={t}
                />
            ) : (
                <GeneralText 
                    t={t}
                    privateEmailChanged={privateEmailChanged}
                />
            )}
        </Alert>
    )
};

const mapStatetoProps = (state) => {
    const { Organization } = state;

    return {
        organization: Organization
    }
}

export default withNamespaces()(
    connect(mapStatetoProps)(
        FinalizeMessage
    )
);